import { leaveRefusedSession } from '~/utils/api'

/**
 * Appels dont un 401 ne ferme aucune session : identifiants ou code refusés, déconnexion d'un jeton
 * déjà expiré (`signOut` efface alors le jeton lui-même).
 */
const CALLS_WITHOUT_SESSION = [
  '/auth/login',
  '/auth/login-admin',
  '/auth/login-admin/mfa',
  '/admin/ask-reset-password',
  '/admin/reset-password',
  '/auth/logout-admin',
]

/**
 * Jeton expiré ou révoqué (401) : retour à la page de connexion, comme le client axios hérité
 * (`utils/api.ts`). Sans ce hook, la page affichait une erreur sur une session morte.
 */
export const leaveSessionOnUnauthorized = (
  request: Request,
  _options: unknown,
  response: Response,
) => {
  if (response.status !== 401) return
  const { pathname } = new URL(request.url)
  if (CALLS_WITHOUT_SESSION.some((path) => pathname.endsWith(path))) return
  leaveRefusedSession()
}
